import React, { useEffect, useState, useRef } from "react"
import MetaTags from "react-meta-tags"
import { withRouter, Link } from "react-router-dom"
import { isEmpty } from "lodash"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import * as moment from "moment"
import FieldValidation from "../../components/Common/FieldValidation"
import { apiError } from "../../store/actions"

import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Badge,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import {
  getAllPermissions,
  createPermission,
  deletePermission,
  editPermission,
} from "../../store/permissions/actions"
//redux
import { useSelector, useDispatch } from "react-redux"
import {
  capitalizeFirstLetter,
  addSlashestoApiNames,
} from "../../helpers/helpers"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

import PermissionDetailsModal from "./PermissionDetailsModal"
import {sitename} from "../../constants/constants";

const Permissions = props => {
  const dispatch = useDispatch()

  const Permissions = useSelector(state => state.permissions.Index ?? [])
  const formErrors = useSelector(state => state?.CommonState)

  const selectRow = {
    mode: "checkbox",
  }

  const [modal, setModal] = useState(false)
  const [detailsModal, setDetailsModal] = useState(false)
  const [permissionList, setPermissionList] = useState([])
  const [isEdit, setIsEdit] = useState(false)

  const superAdminPermissions = [
    "create-super-admins",
    "read-super-admins",
    "update-super-admins",
    "delete-super-admins",
  ]
  //pagination customization
  const pageOptions = {
    sizePerPage: 10,
    totalSize: Permissions.length,
    custom: true,
  }
  const { SearchBar } = Search

  const toggleViewModal = () => setDetailsModal(!detailsModal)

  const PermissionsColumns = toggleModal => [
    {
      dataField: "id",
      text: "Permission ID",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <div className="text-body fw-bold">{row.id}</div>
      ),
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => {
        let { name } = row
        name = name.replace(/-/g, " ")
        name = capitalizeFirstLetter(name)
        return <div className="text-body fw-bold capitalize">{name}</div>
      },
    },
    {
      dataField: "action",
      isDummyField: true,
      text: "Action",
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, permission) => {
        if (permission["editable"] == 1) {
          return (
            <>
              <div className="d-flex gap-3">
                <Link
                  to="#"
                  className="text-success"
                  onClick={() => handleEditPermission(permission)}
                >
                  <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                  <UncontrolledTooltip placement="top" target="edittooltip">
                    Edit
                  </UncontrolledTooltip>
                </Link>
                <Link
                  to="#"
                  className="text-danger"
                  onClick={() => handleDeletePermission(permission)}
                >
                  <i
                    className="mdi mdi-delete font-size-18"
                    id="deletetooltip"
                  />
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    Delete
                  </UncontrolledTooltip>
                </Link>
              </div>
            </>
          )
        }
      },
    },
    // {
    //   dataField: "view",
    //   isDummyField: true,
    //   text: "View Details",
    //   sort: true,
    //   // eslint-disable-next-line react/display-name
    //   formatter: () => (
    //     <Button
    //       type="button"
    //       color="primary"
    //       className="btn-sm btn-rounded"
    //       onClick={toggleViewModal}
    //     >
    //       View Details
    //     </Button>
    //   ),
    // },
  ]
  useEffect(() => {
    dispatch(getAllPermissions())
  }, [])
  const toggle = () => {
    setModal(!modal)
  }

  const toLowerCase1 = str => {
    return str.toLowerCase()
  }

  const handleOrderClick = arg => {
    const order = arg

    setPermissionList({
      id: order.id,
      orderId: order.orderId,
      billingName: order.billingName,
      orderdate: order.orderdate,
      total: order.total,
      paymentStatus: order.paymentStatus,
      paymentMethod: order.paymentMethod,
      badgeclass: order.badgeclass,
    })

    setIsEdit(true)

    toggle()
  }

  var node = useRef()
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page)
    }
  }

  const handleDeletePermission = permission => {
    if (permission.id !== undefined) {
      dispatch(deletePermission(permission.id))
    }
  }
  const handleEditPermission = permission => {
    setPermissionList({
      id: permission.id,
      name: capitalizeFirstLetter(permission.name.replace(/-/g, " ")),
    })

    setIsEdit(true)
    dispatch(apiError(""))

    toggle()
  }

  const handleValidPermissionSubmit = (e, values) => {
    if (isEdit) {
      const permission = {
        name: addSlashestoApiNames(values["Name"]),
        id: permissionList.id,
      }

      // edit permission
      dispatch(editPermission(permission, toggle))
    } else {
      const permission = {
        name: addSlashestoApiNames(values["Name"]),
      }
      // save new permission
      dispatch(createPermission(permission, toggle))
    }
  }

  const handleOrderClicks = () => {
    setPermissionList("")
    setIsEdit(false)
    toggle()
  }

  const handleValidDate = date => {
    const date1 = moment(new Date(date)).format("DD MMM Y")
    return date1
  }

  const defaultSorted = [
    {
      dataField: "orderId",
      order: "desc",
    },
  ]

  return (
    <React.Fragment>
      <PermissionDetailsModal isOpen={detailsModal} toggle={toggleViewModal} />
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Admin" breadcrumbItem="Permissions" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField="id"
                    columns={PermissionsColumns(toggle)}
                    data={Permissions}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="id"
                        data={Permissions}
                        columns={PermissionsColumns(toggle)}
                        bootstrap4
                        search
                      >
                        {toolkitProps => (
                          <React.Fragment>
                            <Row className="mb-2">
                              <Col sm="4">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <SearchBar {...toolkitProps.searchProps} />
                                    <i className="bx bx-search-alt search-icon" />
                                  </div>
                                </div>
                              </Col>
                              <Col sm="8">
                                <div className="text-sm-end">
                                  <Button
                                    type="button"
                                    color="success"
                                    className="btn-rounded  mb-2 me-2"
                                    onClick={handleOrderClicks}
                                  >
                                    <i className="mdi mdi-plus me-1" />
                                    Create New Permission
                                  </Button>
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    keyField="id"
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    defaultSorted={defaultSorted}
                                    selectRow={selectRow}
                                    classes={
                                      "table align-middle table-nowrap table-check"
                                    }
                                    headerWrapperClasses={"table-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                    ref={node}
                                    rowClasses={"mytable-hover-row"}
                                  />
                                </div>
                                <Modal
                                  isOpen={modal}
                                  toggle={toggle}
                                  centered={true}
                                >
                                  <ModalHeader toggle={toggle} tag="h4">
                                    {!!isEdit
                                      ? "Edit Permission"
                                      : "Create New Permission"}
                                  </ModalHeader>
                                  <ModalBody>
                                    <AvForm
                                      onValidSubmit={
                                        handleValidPermissionSubmit
                                      }
                                    >
                                      <Row form>
                                        <Col className="col-12">
                                          <div className="mb-3">
                                            <AvField
                                              name="Name"
                                              label="Name"
                                              type="text"
                                              errorMessage="This is a required field"
                                              validate={{
                                                required: { value: true },
                                              }}
                                              value={permissionList.name || ""}
                                              className={
                                                formErrors && formErrors?.name
                                                  ? "av-invalid is-invalid"
                                                  : "form-control"
                                              }
                                            />
                                          </div>
                                          {formErrors?.name ? (
                                            <FieldValidation
                                              errorMessage={formErrors?.name}
                                            />
                                          ) : null}
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col>
                                          <div className="text-end">
                                            <button
                                              type="submit"
                                              className="btn btn-success save-user"
                                            >
                                              Save
                                            </button>
                                          </div>
                                        </Col>
                                      </Row>
                                    </AvForm>
                                  </ModalBody>
                                </Modal>
                              </Col>
                            </Row>
                            <Row className="align-items-md-center mt-30">
                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </Col>
                            </Row>
                          </React.Fragment>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Permissions)
